export default class SpTracking {
    constructor(element, spContainer, spForm, gtm) {
        this.gtm = gtm;
        this.$element = $(element);
        this.$container = $(spContainer);
        this.$form = $(spForm);

        // we want to keep order
        this.formElements = [
            this.$container.find('#maker'),
            this.$container.find('#model'),
            this.$container.find('#zipcode'),
            this.$container.find('#attr_km'),
            this.$container.find('#attr_m_year'),
            this.$container.find('#attr_m_month'),
        ];
    }

    init() {
        this.$element.addClass('gtm-initialized');
        this.$element.on('click', $.proxy(this, 'trackEvent'));

        this.formElements.forEach((el) => {
            if (el.prop('required')) {
                el.on('change', (el) => {
                    $(el.target).removeClass('invalid');
                });
                el.on('keydown', (el) => {
                    $(el.target).removeClass('invalid');
                });
            }
        });
    }

    getSpEventLabel() {
        return this.formElements.map(el => this.getDropdownValue(el) || el.val() || 'NULL').join('|');
    }

    validate() {
        let ret = true;

        this.formElements.forEach((el) => {
            if(el.prop('required') && (el.find(':selected').val() === '' || !el.val())) {
                ret = false;
                el.addClass('invalid');
            }

            // dirty hack for a temp page..
            if(el.prop('id') === 'model' && el.find(':selected').text() === 'Tutti i modelli') {
                ret = false;
                el.addClass('invalid');
            }
        });

        return ret;
    }

    trackEvent() {
        if (!this.validate()) {
            return false;
        }

        this.gtm.trackEvent(this.$element.data('sp-tracking'), this.getSpEventLabel());

        setTimeout(() => {
            location.href = 'https://www.kijiji.it/pubblica-annuncio';
        }, 5000);
    }

    getDropdownValue(element) {
        return (element.find(':selected').val() !== '') ? element.find(':selected').text() : 'NULL';
    }
}
